// extracted by mini-css-extract-plugin
export default {"col":"z24nr","footerSubscription":"Ala9F","wrapperMedium":"XrHa6","wrapperBig":"Q8onK","grid":"lLnV2","linkWrapper":"tFIAS","popoverInfo":"wS7rQ","popover":"q1C4B"};